var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.daytypeOptions,"reduce":label => label.code,"label":"label"},model:{value:(_vm.daytype),callback:function ($$v) {_vm.daytype=$$v},expression:"daytype"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }